import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <div className="mb-4">
              <img 
                src="/redtop-logo.png" 
                alt="Redtop Contracting" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-sm text-gray-400">
              Professional home improvement services with a commitment to quality and customer satisfaction.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-red-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-sm hover:text-red-500 transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-red-500 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-red-500 transition-colors cursor-pointer">Kitchen Remodels</li>
              <li className="hover:text-red-500 transition-colors cursor-pointer">Bathroom Remodels</li>
              <li className="hover:text-red-500 transition-colors cursor-pointer">Flooring</li>
              <li className="hover:text-red-500 transition-colors cursor-pointer">Full Renovations</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone size={16} className="text-red-500 mt-1 flex-shrink-0" />
                <div className="text-sm">
                  <a href="tel:6318280468" className="hover:text-red-400 transition-colors">631-828-0468</a>
                  <div className="text-xs text-gray-400 mt-1">Text or Call</div>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={16} className="text-red-500 mt-1 flex-shrink-0" />
                <a href="mailto:redtopcontracting@gmail.com" className="text-sm hover:text-red-400 transition-colors">redtopcontracting@gmail.com</a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={16} className="text-red-500 mt-1 flex-shrink-0" />
                <span className="text-sm">Serving from Suffolk County to Lower Westchester</span>
              </li>
            </ul>
            <div className="flex space-x-4 mt-6">
              <a 
                href="https://instagram.com/redtopcontracting" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-red-500 transition-colors"
                aria-label="Follow us on Instagram"
              >
                <Instagram size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Redtop Contracting & Consulting. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;